/**
 * Tiny cookie reader. Mirrors the existing `document.cookie.split(';')`
 * pattern used across the app, centralized so the multi-tenant interceptor
 * (and any future caller) can read a cookie value without a new dependency.
 *
 * Returns the raw (still URL-encoded) cookie value, or `null` when absent.
 * The value is treated as opaque by callers — it is never parsed here.
 */
export const getCookie = (name: string): string | null => {
  if (typeof document === 'undefined' || !document.cookie) {
    return null
  }

  const cookies = document.cookie.split(';')
  const match = cookies.find((cookie) => cookie.trim().startsWith(`${name}=`))
  if (!match) {
    return null
  }

  const value = match.slice(match.indexOf('=') + 1).trim()
  return value.length > 0 ? value : null
}
